import { BreadcrumbsItem, CommonProp, generate, MainNavHorizontal } from '@acin/ui-core';
import { useAuth } from '@acin/user-accounts';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { getPathFromId, ROUTES } from '../../../routes/routes';
import { INavigationItem } from '../../../types';
import * as SC from './MainNav.styled';

export interface MainNavProps extends CommonProp {
  className?: string;
  breadcrumbs?: BreadcrumbsItem[];
  onBreadcrumbsClick?: (item: BreadcrumbsItem) => void;
}

const navigation: INavigationItem[] = [
  {
    id: ROUTES.REGULATIONS_OVERVIEW.id,
    label: ROUTES.REGULATIONS_OVERVIEW.label,
  },
  {
    id: ROUTES.CONTROL_MAPPINGS.id,
    label: ROUTES.CONTROL_MAPPINGS.label,
  },
];

const isRouteActive = (pathname: string, routePath: string) => {
  // Remove any dynamic segments from the route path for comparison
  const dynamicSegmentIndex = routePath.indexOf('/:');
  const pathPrefix = dynamicSegmentIndex === -1 ? routePath : routePath.slice(0, dynamicSegmentIndex);

  if (pathPrefix === '/') {
    return pathname === '/';
  }

  return pathname === pathPrefix || pathname.startsWith(`${pathPrefix}/`);
};

const SETTINGS_MENU = {
  LOGOUT: 'logout',
};

export const MainNav: React.FC<MainNavProps> = (props) => {
  const { className, breadcrumbs, onBreadcrumbsClick } = props;
  const history = useHistory();
  const location = useLocation();
  const { user, logout } = useAuth();

  const activeItem = navigation.find((item) => {
    const path = getPathFromId(item.id);
    return path ? isRouteActive(location.pathname, path) : false;
  })?.id;

  const settingsMenu = [{ id: SETTINGS_MENU.LOGOUT, label: 'Logout' }];

  const goToDashboard = () => {
    history.push('/');
  };

  const handleNavigationClick = (item: INavigationItem) => {
    const path = Object.values(ROUTES).find((route) => route.id === item.id)?.path;

    if (path) {
      history.push(path);
    }
  };

  const handleMenuClick = (id?: string) => {
    switch (id) {
      case SETTINGS_MENU.LOGOUT:
        localStorage.clear();
        let redirect = {
          returnTo: `https://${window.location.hostname}`,
        };
        if (process.env.NODE_ENV === 'development') {
          redirect = {
            returnTo: 'http://localhost:3001',
          };
        }
        logout(redirect);
        break;
    }
  };

  return (
    <SC.MainNav data-testid={generate(['main-nav'], props)} className={className}>
      <MainNavHorizontal
        navigation={navigation}
        activeItem={activeItem}
        onNavigationClick={handleNavigationClick}
        onLogoClick={goToDashboard}
        settingsMenuContents={settingsMenu}
        onOpenSettings={() => {}}
        onMenuClick={(item) => handleMenuClick(item?.id)}
        breadcrumbs={breadcrumbs}
        onBreadcrumbsClick={onBreadcrumbsClick}
        variant="accent1"
        userEmail={user && user.email}
      />
    </SC.MainNav>
  );
};
